module.exports = __webpack_public_path__ + "static/media/Data-backup.31606c07.svg";